<template>
  <div class="talkWithGuide-Confirmation">
      <div>
          <img src="/img/shaka-emoji.png" alt="Shaka Emoji">
      </div>
      <div class="pageTitle">We'll reach out {{ reachOutTimeframe }}</div>
      <p class="pageSubtitle">
          <span v-if="isBusinessHours">
                A guide will call you within 30 minutes
            </span>
            <span v-if="!isBusinessHours">
                A guide will call you during business hours (8am - 9pm CST)
            </span>
        </p>
      <button v-if="hasDone" type="button" @click="toggleTalkWithGuideVisible">Done</button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
props: {
    changeSection: Function,
    hasDone: {
        default: true
    }
},
  computed: {
      ...mapState([
          'lead',
          'isBusinessHours'
      ]),

      reachOutTimeframe() {
          return 'soon...'
      },

      callText() {
          return 'within 5 minutes.'
      }
  },
  methods: {
      ...mapMutations([
          'toggleTalkWithGuideVisible'
      ])
  }
}
</script>

